import { render, staticRenderFns } from "./RateDetail.vue?vue&type=template&id=cc26404e&"
import script from "./RateDetail.vue?vue&type=script&lang=js&"
export * from "./RateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports